export enum IdentifierType {
  Spaceman = 'SPACEMAN',
  SpacemanCode = 'SPACEMAN_CODE',
  WeCode = 'WECODE'
}
